<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
  >
    <div class="bg-eerie-black p-6 rounded-lg shadow-lg text-center max-w-sm w-full mx-4">
      <h2 class="text-xl text-total-white font-bold mb-4">
        {{ heading }}
      </h2>

      <p class="text-sm text-total-white-500 mb-6">
        {{ message }}
      </p>

      <div class="flex items-center gap-4 w-full justify-center">
        <!-- Contact Us Link -->
        <router-link
          :to="contactRoute"
          class="bg-prime-golden w-fit text-black font-semibold px-3 py-1 rounded-lg"
        >
          {{ linkText }}
        </router-link>

        <button
          @click="closeModal"
          class="bg-gray-700 w-fit text-white font-semibold px-3 py-1 rounded-lg"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    heading: {
      type: String,
      default: "Error",
    },
    message: {
      type: String,
      default: "An unexpected error occurred.",
    },
    linkText: {
      type: String,
      default: "Contact Us for help",
    },
    contactRoute: {
      type: [String, Object],
      default: "/contact",
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
/* ErrorModal styling follows your design system */
</style>
